import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import GeometricBackground from './GeometricBackground';

const HomePage = () => {
  const [walletAddress, setWalletAddress] = useState('');
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "IRScan AI - Best Solana Tax Calculator";
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!walletAddress.trim()) {
      setError('Please enter a wallet address');
      return;
    }

    if (!/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(walletAddress.trim())) {
      setError('Please enter a valid Solana wallet address');
      return;
    }

    navigate(`/dashboard/${walletAddress.trim()}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="fixed inset-0">
        <GeometricBackground />
      </div>
      
      <div className="relative z-10">
        <Navbar />
        
        <main className="flex min-h-[calc(100vh-80px)] items-center justify-center px-4">
          <div className="max-w-4xl w-full py-12 space-y-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center"
            >
              <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold font-space-grotesk bg-gradient-to-r from-[#BFEA15] to-[#D9F273] bg-clip-text text-transparent mb-6">
                Track Your Crypto Taxes
              </h1>
              <p className="text-lg sm:text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
                Simplify your Solana tax reporting with real-time portfolio tracking and AI-powered tax calculations
              </p>

              <motion.form
                onSubmit={handleSubmit}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="flex flex-col items-center space-y-4"
              >
                <div className="w-full max-w-xl">
                  <div className="relative">
                    <input
                      type="text"
                      value={walletAddress}
                      onChange={(e) => setWalletAddress(e.target.value)}
                      placeholder="Enter your Solana wallet address"
                      className="w-full px-6 py-4 bg-white/10 backdrop-blur-md rounded-xl border border-white/20 shadow-lg text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#BFEA15]/50 transition-all"
                    />
                    {error && (
                      <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="absolute -bottom-6 left-0 text-sm text-red-500"
                      >
                        {error}
                      </motion.p>
                    )}
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="px-8 py-3 bg-[#BFEA15] rounded-lg text-gray-900 font-medium hover:bg-[#BFEA15]/90 transition-colors shadow-lg"
                  >
                    Get Started
                  </button>
                </div>
              </motion.form>

              <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
                <span 
                  onClick={() => {
                    navigator.clipboard.writeText('Eu2Yy6EXirRnrE74rUFErrgtFRbPbNzpmrd7AgLcpump');
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2000);
                  }}
                  className="text-gray-600 text-sm cursor-pointer"
                >
                  Contract Address: <span className="font-mono">Eu2Yy6EXirRnrE74rUFErrgtFRbPbNzpmrd7AgLcpump</span>
                  {copied && <span className="text-xs text-green-500 ml-2">(Copied!)</span>}
                </span>
              </div>
            </motion.div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default HomePage;
